import * as React from 'react'
import styled from 'styled-components'
import theme from './theme.js'
import {BodyText} from './text.js'
import useApp from './use-app-context.js'

const ActionBar = () => {
  const app = useApp()
  const bar = app.actionBar
  const text = bar.text
  const isActive = bar.isActive
  const props = {isActive}

  return (
    <Bar {...props}>
      <Text>{text}</Text>
    </Bar>
  )
}

const Bar = styled.div`
  position: fixed;
  bottom: ${props => props.isActive ? '0' : '-' + theme.pad.medium};
  opacity: ${props => props.isActive ? 1 : 0};
  transition: bottom .3s, opacity .3s;
  left: 0;
  width: 100%;
  height: ${theme.pad.medium};
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${theme.color.grey.darker};
  z-index: 100;
`

const Text = styled(BodyText)`
  color: white;
`

export default ActionBar